import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  Row,
  Col
} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

class DocListAllModal extends Component {
    constructor(props) {
        super(props);
        this.preRole = "";
    }

    getRefMessageId = (doc) => {
        if (doc.ref_id) {
            return doc.ref_id.replace('message_', '');
        }
        return "";
    }

    renderDoc = (doc, index) => {
        var role = doc.metadata.message_role;
        if (role == 'tool' || role == 'system') {
            role = 'assistant_' + role;
        }
        var extraComponent = (index == 0 && role == 'user' || this.preRole.split('_')[0] != role.split('_')[0]) ? <></> : <Col md="6"></Col>;
        this.preRole = role;

        var docComponent = <Col key={doc._id} md="6" className="mb-3">
        <Card className={`doc-bg-${role.split('_')[0]}`}>
          <CardBody>
            {/* <h5 className="mb-3">{doc.doc_mid}</h5> */}
            <a href={`/v1/k3pl-chat?messageId=${this.getRefMessageId(doc)}`} target="_blank" rel="noopener noreferrer">Message ID: {this.getRefMessageId(doc)}</a>

            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
              children={doc.content}
            />
          </CardBody>
        </Card>
      </Col>

        return <>
            {extraComponent}
            {docComponent}
        </>
    }

  render() {
    const { isOpen, toggle, title, docs } = this.props;

    if (docs == null || docs.length == 0) {
      return "";
    }

    return (
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xl modal-dialog-centered modal-doc-list" style={{ 
        maxWidth: '95vw',
        margin: '0 auto'
      }}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody style={{ 
          height: '80vh',
          overflowY: 'auto',
          padding: '1rem'
        }}>
          <Row>
            {docs.map((doc, index) => this.renderDoc(doc, index))}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default DocListAllModal; 